export { default } from "./ComponentResolver";
export * from "./ComponentResolver";
